import { render, staticRenderFns } from "./AtheleteIndex.vue?vue&type=template&id=e1315dc6&"
import script from "./AtheleteIndex.vue?vue&type=script&lang=js&"
export * from "./AtheleteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports